const en = {
  // Navigation
  nav_plan: 'Plan',
  nav_itinerary: 'Itinerary',
  nav_saved: 'Saved',

  // Header
  explore_photos: 'Explore photos',
  sign_in: 'Sign in',

  // Plan screen
  new_trip: '+ New trip',
  add_city_header: 'Add City',
  city_placeholder: 'Enter a city name...',
  add_cities_empty: 'Add cities to start planning your trip',
  dest_bangkok: 'Bangkok', dest_paris: 'Paris', dest_london: 'London', dest_dubai: 'Dubai',
  dest_singapore: 'Singapore', dest_tokyo: 'Tokyo', dest_new_york: 'New York',
  dest_istanbul: 'Istanbul', dest_kuala_lumpur: 'Kuala Lumpur', dest_seoul: 'Seoul',
  hero_badge: 'AI-powered trip planning',
  hero_title_line1: 'Your next trip,',
  hero_title_line2: 'perfectly planned.',
  hero_subtitle: 'Tap a destination to start planning instantly',
  most_visited_label: 'Most visited destinations',
  popular_destinations: 'Popular destinations',
  or_type_your_own: 'or type your own',
  where_going_label: 'Where are you going?',
  expanding_region: (r) => `Finding top cities in ${r}…`,
  tap_to_explore: '— tap to explore',
  attraction_count: (n) => `${n} ${n === 1 ? 'attraction' : 'attractions'}`,
  show_less: 'Show less',
  read_more: 'Read more',
  more: 'More',
  less: 'Less',
  no_attractions: 'No attractions added yet',
  add_attraction_placeholder: (city) => `Add attraction in ${city}...`,
  auto_add_title: 'Auto-add recommended attractions',
  preferences_label: 'Interests',
  all_types_label: 'All types',
  edit_interests: 'Edit interests…',
  plan_framing_msg: 'Keep what you like, remove the rest — then generate your day-by-day plan.',
  add_back: 'Add back',
  added_label: 'Added',
  refresh_attractions: 'Refresh attractions',
  plan_multi_summary: (n, m) => `${n} ${n === 1 ? 'city' : 'cities'} · ${m} ${m === 1 ? 'place' : 'places'}`,
  filter_onboarding_msg: 'Personalize your attractions',
  filter_onboarding_sub: 'Tap a type to refocus — we\'ll regenerate with that filter.',
  explore_nearby: 'Explore nearby places',
  explore_nearby_sub: 'Browse photos of must-see spots for your trip',
  finding_attractions: 'Finding attractions...',
  finding_attractions_1: 'Asking AI for top picks...',
  finding_attractions_2: 'Finding must-see spots...',
  finding_attractions_3: 'Almost there...',
  generating_msg_1: 'Planning your days...',
  generating_msg_2: 'Finding the best spots...',
  generating_msg_3: 'Crafting your itinerary...',
  view_itinerary: 'View Itinerary',
  generate_itinerary: 'Generate Itinerary',
  filterLabel: (label) => ({ 'All': 'All', 'Culture': 'Culture', 'Nature': 'Nature', 'Entertainment': 'Entertainment', 'Shopping': 'Shopping', 'Food & Drink': 'Food & Drink', 'Kids': 'Kids', 'Seniors': 'Seniors' })[label] ?? label,

  // Itinerary screen
  rename: 'Rename',
  days: (n) => `${n} days`,
  unsaved_dot: 'Unsaved changes',
  share_itinerary: 'Share itinerary',
  copy: 'Copy',
  copied: 'Copied!',
  add_more_attractions: 'Add More Attractions',
  search_city_placeholder: 'Search for a city...',
  plus_city: '+ City',
  your_cities: 'Your cities',
  unscheduled_count: (n) => `Unscheduled Attractions (${n})`,
  drag_to_schedule: 'Drag these to days to schedule them',
  loading_details: 'Loading details…',
  drag_here: 'Drag an attraction here',
  day_label: (n) => `Day ${n}`,
  activity_count: (n) => `${n} ${n === 1 ? 'activity' : 'activities'}`,
  add_note: '+ Add note',
  note_placeholder: 'Add notes for this day — hotel details, lunch ideas, reminders...',
  save_note: 'Save note',
  cancel: 'Cancel',
  continue_in_city: 'Continue in an existing city',
  change_back: '← Change',
  save: 'Save',
  hotel_nights_label: 'Nights',
  hotel_name_label: 'Hotel name',
  restaurant_label: 'Restaurant (optional)',
  search_hotel: 'Search hotel…',
  search_restaurant: 'Search restaurant…',
  searching: 'Searching…',
  address_label: 'Address',
  time_label: 'Time',
  duration_label: 'Duration',
  notes_label: 'Notes',
  time_placeholder: 'e.g., 9:00 AM',
  duration_placeholder: 'e.g., 2 hours',
  notes_placeholder: 'e.g., check-in at 3pm, pool view room…',
  drag_to_reorder: 'Drag to reorder',
  details: 'Details',
  edit: 'Edit',
  snip: 'Snip',
  remove: 'Remove',
  move_to_day_picker: 'Move to day…',
  trip_start_date: 'Trip starts',
  itinerary_photo_sub: 'AI-powered suggestions based on your cities',
  itinerary_photo_cta: 'Find hidden gems for your trip',
  hotel: 'Hotel',
  meal_at: (restaurant) => `at ${restaurant}`,
  add_day: 'Add Day',
  save_changes: 'Save Changes',
  saved_check: 'Saved ✓',
  save_itinerary: 'Save Itinerary',
  print_export: '🖨️ Print / Export PDF',
  photos_details: 'Photos & details',

  // Saved screen
  sign_in_to_save: 'Sign in to save and view your trips',
  snip_requires_account: 'Create a free account to save bookmarks',
  sign_in_or_create: 'Sign in or create account',
  snips: 'Snips',
  place_count: (n) => `${n} ${n === 1 ? 'place' : 'places'}`,
  trips: 'Trips',
  loading_trips: 'Loading trips...',
  no_saved_trips: 'No saved trips yet',
  add_to_plan: 'Add to Plan',
  add_to_itinerary_btn: 'Add to Itinerary',
  untitled_trip: 'Untitled Trip',
  open: 'Open',

  // User menu
  signed_in_as: 'Signed in as',
  change_password: 'Change Password',
  delete_user_menu: 'Delete User',
  sign_out: 'Sign out',

  // Load saved trip confirmation
  load_trip_confirm_title: 'Open saved trip?',
  load_trip_confirm_msg: 'Your current plan will be discarded. Make sure it\'s saved first if you want to keep it.',

  // New trip confirmation
  unsaved_changes_title: 'Unsaved changes',
  unsaved_changes_msg: 'Your current trip has unsaved changes. Start a new trip anyway?',
  discard_start_new: 'Discard & start new',
  new_trip_tab_title: 'Start a new trip?',
  new_trip_tab_msg: 'Your current itinerary will be cleared. Make sure it\'s saved first if you want to keep it.',
  start_fresh: 'Start fresh',

  // Auth modal
  create_account: 'Create account',
  email_placeholder: 'Email',
  password_placeholder: 'Password',
  i_agree_to: 'I agree to the',
  terms_of_service: 'Terms of Service',
  privacy_policy: 'Privacy Policy',
  and: 'and',
  no_account: "Don't have an account? ",
  have_account: 'Already have an account? ',
  network_error: 'Network error, please try again',
  err_email_exists: 'An account with this email already exists',
  err_invalid_credentials: 'Invalid email or password',
  err_email_password_required: 'Email and password are required',
  err_password_too_short: 'Password must be at least 6 characters',

  // Change password modal
  select_user: 'Select user...',
  new_password_placeholder: 'New password (min 6 chars)',
  update_password: 'Update Password',
  password_updated: 'Password updated',
  select_a_user: 'Select a user',
  network_error_short: 'Network error',

  // Delete user modal
  delete_user_trips: 'Delete User & Trips',
  deleted_user: (email) => `Deleted ${email}`,

  // Photo mode
  photo_loading_msg_1: 'Finding stunning spots for you…',
  photo_loading_msg_2: 'Checking photos and details…',
  photo_loading_msg_3: 'Almost ready…',
  finding_places: 'Finding places for you…',
  could_not_load_places: 'Could not load places',
  no_places: 'No places to show',
  ai_error: 'There was a problem reaching the AI. Try again in a moment.',
  add_cities_suggestions: 'Add cities or save some places to get personalised suggestions.',
  retry: 'Retry',
  close: 'Close',
  finding_more_places: 'Finding more places…',
  seen_it_all: "You've seen it all!",
  photo_limit_msg: 'You reached the 50-place limit for this session.',
  check_snips: 'Check your Snips to review saved places',
  photo_unavailable: 'Photo unavailable',
  loading: 'Loading…',
  skip: 'Skip',
  plus_itinerary: '+ Itinerary',
  plus_plan: '+ Plan',
  photo_explore_title: 'Photo Explore',
  photo_explore_sub: 'Discover places, visually',
  swipe_lr: 'Swipe left or right to skip',
  swipe_up: 'Swipe up to skip',
  lets_go: "Let's go",
  tutorial_skip_desc: 'Pass on this place',
  tutorial_snip_desc: 'Save to your Snips collection to revisit later',
  tutorial_add_plan_desc: 'Add to your Plan tab to build your trip',
  tutorial_add_itinerary_desc: 'Drop directly into your current itinerary',
  tutorial_swipe_hint: 'You can also swipe left, right, or up to skip',

  // Footer
  copyright: '© 2026 Pazzie Inc.',
  terms: 'Terms',
  privacy: 'Privacy',
  sample_itineraries: 'Sample Itineraries',
  browse_all_itineraries: 'Browse all →',

  // Legal overlay
  back_to_app: '← Back to SnipTrip',

  // Error boundary
  something_wrong: 'Something went wrong',
  reload: 'Reload',

  // Print view
  copy_text: 'Copy text',
  copied_check: '✓ Copied',

  // Logic / computed strings
  copy_of: (name) => `Copy of ${name}`,
  transportation: 'Transportation',
  meal: 'Meal',

  // Chat mode
  chat_mode_link: 'or plan with AI chat',
  chat_back: '← Back to Build',
  chat_input_placeholder: 'Message…',
  chat_error: 'Something went wrong. Try again?',
  chat_cities_count: (n) => n === 1 ? '1 city' : `${n} cities`,
  chat_places_count: (n) => n === 1 ? '1 place' : `${n} places`,
  chat_no_cities: 'No cities added yet',

  // Discovery panels
  thinking_where: 'Thinking about where to take you…',
  couldnt_load_suggestions: "Couldn't load suggestions. Try again?",
  back: '← Back',
  no_new_suggestions: 'No new suggestions — try a different question.',
  back_to_questions: '← Back to questions',
  dismiss: 'Dismiss',
  where_to_next_header: 'Where to next?',
  describe_place: 'Describe the kind of place…',
  go: 'Go',
  finding_ideas: 'Finding ideas…',
  more_attractions: 'More attractions…',
  different_angle: 'Or explore a different angle:',
  mood_for: 'What are you in the mood for?',
  back_questions_short: '← Questions',
  describe_looking_for: "Describe what you're looking for…",
  where_to_next_trigger: (city) => city ? `+ Where to next after ${city}?` : '+ Where to next?',
  what_else_trigger: (city) => `+ What else should I add near ${city}?`,
  day_chip_add_attraction: 'Add an attraction',
  day_chip_add_city: 'Add a city nearby',
  auto_populate_prompt: (city) => `Auto-suggest popular attractions for ${city}?`,
  auto_populate_yes: 'Yes, suggest some',
  auto_populate_no: "No, I'll add manually",
  or_discover_new: '+ Or discover somewhere new',
  select: 'Select',
  add: 'Add',
  freeform_cta: 'Something else — describe it myself',
};

export default en;
